/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, DotsHorizontalIcon } from '@heroicons/react/solid';
import cs from 'classnames';

export function Dropdown({
    label,
    options = [],
    right,
    ellipse,
    classContainer,
    classDropdown,
}: {
    label: string;
    options: React.ReactNode[];
    right: boolean;
    ellipse: boolean;
    classContainer?: string;
    classDropdown?: string;
}) {
    const rightToLeft = right ? 'origin-top-right right-0' : 'origin-top-left left-0';
    const Icon = ellipse ? DotsHorizontalIcon : ChevronDownIcon;
    const classButton = cs(
        'inline-flex justify-center w-full px-4 py-2 bg-transparent text-sm font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary',
        {
            'border border-gray-300 rounded-md shadow-sm': !ellipse,
        },
        classContainer,
    );

    const iconStyle = cs('h-5 w-5', {
        '-mr-1 ml-2': !ellipse,
    });

    return (
        <Menu as="div" className="relative inline-block text-left">
            {({ open }) => (
                <>
                    <div className="h-5 w-5">
                        <Menu.Button className={classButton}>
                            {label}
                            <Icon className={iconStyle} aria-hidden="true" />
                        </Menu.Button>
                    </div>
                    <Transition
                        show={open}
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95">
                        <Menu.Items
                            static
                            className={`${rightToLeft} overflow-hidden z-1000 absolute mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-non ${classDropdown}`}>
                            <div className="">
                                {options.map((Opt, idx) => (
                                    <Menu.Item key={idx}>{Opt}</Menu.Item>
                                ))}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    );
}
